import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';

interface GoalChartDTO {
  FinancialPlanVersion: string;
  GoalChart: any;
  GoalList: { Id: string; Name: string; ChartName: string };
}

interface FetcherParams {
  clientId: string;
  fpId: string;
}

const fetchGoalChart = async ({ clientId, fpId }: FetcherParams): Promise<GoalChartDTO> => {
  return authFetch(
    urlWithParams('/Consumer/GoalChart', {
      clientId,
      fpId,
    }),
  );
};

interface QueryParams {
  clientId: string;
  fpId: string;
}

export const useGoalChartQuery = ({ clientId, fpId }: QueryParams) => {
  return useQuery(
    queryKeys.goalChart(clientId, fpId),

    () => fetchGoalChart({ clientId, fpId }),
  );
};
